import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import CircularProgress from '@mui/material/CircularProgress';
import '../common.css';

function ExpenseHeadIndex() {
  const { isAuthenticated, companyId, logout, token } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }
    fetchTableData();
  }, [isAuthenticated, companyId, token, logout]);

  const fetchTableData = async () => {
    setLoading(true);
    fetchData('ExpenseHeadApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Expense Head Details:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  return (
    <div className="page-container">
      {loading && (
        <div className="loading-overlay">
          <CircularProgress size={40} className="loading-spinner" />
          <span className="loading-text">Loading...</span>
        </div>
      )}

      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">Account Head</h1>
        <div className="header-actions">
          <div className="search-box">
            <SearchIcon />
            <input
              type="text"
              className="search-input"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <Link to="/ExpenseHeadCreate" className="create-btn">
            <AddIcon fontSize="small" />
            Add Account Head
          </Link>
        </div>
      </div>

      {/* Table */}
      <div className="table-container">
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Account Head Name</th>
                <th>Remarks</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <tr key={item.Id}>
                    <td>{index + 1}</td>
                    <td className="cell-primary">{item.Name}</td>
                    <td>{item.Remarks}</td>
                    <td>
                      <span className={`cell-badge ${item.ExpenseOrIncome === 'Income' ? 'income' : ''}`} 
                            style={{ background: item.ExpenseOrIncome === 'Income' ? '#d1fae5' : '#fee2e2', 
                                     color: item.ExpenseOrIncome === 'Income' ? '#059669' : '#dc2626' }}>
                        {item.ExpenseOrIncome}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <Link to={`/ExpenseHeadEdit/${item.ID}`}>
                          <button className="action-btn edit" title="Edit">
                            <EditIcon fontSize="small" />
                          </button>
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">
                    <div className="empty-state">
                      <p>No account heads found</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ExpenseHeadIndex;
